export default "__VITE_ASSET__58336d3b__"